import { useRef } from "react";
import Actor from "../models/Actor";
import Channel from "../models/Channel";
import { channelTypeInfo, ChannelType, getChannelTypePicture } from "../models/ChannelType";
import { ConnectionType, highlightConnections, dehighlightConnections } from "../models/Connection";
import Page from "../models/Page";
import { PagePrintInfo } from "../models/PagePrintInfo";
import { onConnectionTargetMouseLeave, onConnectionTargetMouseMove } from "./ConnectionTarget";

export default function ActorHeader(props: { actor: Actor; page: Page; print?: PagePrintInfo }) {
  const { actor, page, print } = props;

  const headerElement = useRef<HTMLDivElement>(null);
  const connectableChannel = useRef<Channel | undefined>();

  function clearConnectableChannel() {
    if (state.currentDrawingConnection.connection) {
      if (connectableChannel.current) {
        connectableChannel.current.selectedForAutoconect = false;
        connectableChannel.current.raiseOnChange();
        if (connectableChannel.current.isNewCreatedFromAutoconnect == true) {
          connectableChannel.current.delete();
        }
      }
    }

    if (connectableChannel.current && headerElement.current) {
      connectableChannel.current.selectedForAutoconect = false;
      connectableChannel.current.raiseOnChange();
      onConnectionTargetMouseLeave(headerElement.current as HTMLDivElement);
    }
  }

  function findConnecableChannel() {
    const connection = state.currentDrawingConnection.connection;
    if (connection && connection.fromDevice) {
      connectableChannel.current = actor.findConnectableChannel(connection.type, connection.fromDevice, "soft");

      if (connectableChannel.current && headerElement.current) {
        connectableChannel.current.selectedForAutoconect = true;
        connectableChannel.current.raiseOnChange();

        onConnectionTargetMouseMove(
          page,
          connectableChannel.current,
          headerElement.current as HTMLDivElement,
          ConnectionType.Channel,
        );
      } else {
        connection.forbidden = true;
        connection.tmpType = undefined;
        connection.toDevice = undefined;
        connection.raiseOnChange("forbidden");
      }
    }
  }

  let supplyText = actor.supplyText;

  const isSupply = channelTypeInfo(actor.channelType).isSupply;

  const channelPicture = getChannelTypePicture(actor.channelType);

  return (
    <div
      ref={headerElement}
      className="header connectionTarget"
      style={{
        breakAfter: "avoid",
        wordBreak: "keep-all",
        breakInside: "avoid",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        paddingBottom: "0px",
        paddingRight: channelTypeInfo(actor.channelType).isSupply ? "0px" : undefined,
        pointerEvents: "auto",
      }}
      onMouseEnter={(ev) => {
        if (print == undefined) {
          ev.stopPropagation();
          if (ev.buttons == 0) {
            highlightConnections(true, page, actor, print);
          }
        }
      }}
      onMouseLeave={(ev) => {
        if (print == undefined) {
          ev.stopPropagation();
          if (ev.buttons == 0) {
            dehighlightConnections(true, page, actor, print);
          } else {
            clearConnectableChannel();
          }
        }
      }}
      onMouseMove={(ev) => {
        if (print == undefined) {
          ev.stopPropagation();
          if (ev.buttons == 1) {
            findConnecableChannel();
          }
        }
      }}
      onMouseUp={(ev) => {
        if (!print) {
          ev.stopPropagation();
          if (connectableChannel.current && state.currentDrawingConnection.page) {
            if (connectableChannel.current?.isNewCreatedFromAutoconnect) {
            }
            state.currentDrawingConnection.connect(connectableChannel.current, ConnectionType.Channel);
          }
        }
      }}
    >
      {!isSupply && (
        <div
          style={{
            padding: "0px",
            overflow: "hidden",
            display: "flex",
            flexDirection: "row",
            justifyContent: "left",
          }}
        >
          <i
            className={`las  la-caret-${state.selectionManager.selectedObject != actor ? "right" : "down"}`}
            style={{ color: "grey" }}
          />

          {channelPicture && (
            <img
              style={{
                marginLeft: "2px",
                marginRight: "2px",
                height: "15px",
                alignSelf: "center",
                opacity: "0.5",
              }}
              src={channelPicture}
            />
          )}

          {`${actor.tag}`}
        </div>
      )}

      {supplyText && (
        <div
          style={{
            fontSize: "0.75rem",
            paddingBottom: "5px",
          }}
        >
          {supplyText}
        </div>
      )}

      {false && !isSupply && actor.selected && <div style={{ fontSize: "0.75rem" }}>{actor.fullPhysicalAddress}</div>}
    </div>
  );
}
